import { Entities } from './entities';

export class PlanningDay {
    public date: Date;
    public entities: Entities[] = [];
    public fixed: boolean;
}
